import store from '@/state/store'
import { Helper } from '@/mixin/helper'

export default [
  {
    path: '/sales-order',
    name: 'Sales Order',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          "sales-order:create",
          "sales-order:delete",
          "sales-order:read",
          "sales-order:update",
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import('@/router/views/sales-order'),
  },
  {
    path: '/sales-order/create',
    name: 'Sales Order Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          "sales-order:create",
          "sales-order:delete",
          "sales-order:read",
          "sales-order:update",
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import('@/router/views/sales-order/detail'),
  },
  {
    path: '/sales-order/:id',
    name: 'Sales Order Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          "sales-order:create",
          "sales-order:delete",
          "sales-order:read",
          "sales-order:update",
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import('@/router/views/sales-order/detail'),
  },
]